import { render, staticRenderFns } from "./FormatObjectEditTool.vue?vue&type=template&id=3f9a087d&scoped=true&"
import script from "./FormatObjectEditTool.vue?vue&type=script&lang=ts&"
export * from "./FormatObjectEditTool.vue?vue&type=script&lang=ts&"
import style0 from "./FormatObjectEditTool.vue?vue&type=style&index=0&id=3f9a087d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9a087d",
  null
  
)

export default component.exports